import { render, staticRenderFns } from "./DashboardEcoDriversDrilldown.vue?vue&type=template&id=82d85a42&scoped=true"
import script from "./DashboardEcoDriversDrilldown.vue?vue&type=script&lang=js"
export * from "./DashboardEcoDriversDrilldown.vue?vue&type=script&lang=js"
import style0 from "./DashboardEcoDriversDrilldown.vue?vue&type=style&index=0&id=82d85a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d85a42",
  null
  
)

export default component.exports